import React from "react";
import {
  beautify,
  formatDateTime,
  NoWrap,
  createViewAction,
} from "../../utils/helpers";
import { FormActions } from "../../components/common/FormActions";
import { URL_BUSINESS_AUDIT_LOGS } from "../../utils/urls";

const url = URL_BUSINESS_AUDIT_LOGS;

export const useBusinessAuditLogs = () => {
  const tableColumns = () => [
    { id: "actor_name", header: "Actor", filter: { type: "text" } },
    { id: "action", header: "Action", filter: { type: "text" } },
    { id: "target_type", header: "Target Type", filter: { type: "text" } },
    { id: "target_id", header: "Target ID", filter: { type: "text" } },
    {
      id: "correlation_id",
      header: "Correlation ID",
      filter: { type: "text" },
    },
    { id: "timestamp", header: "Date", filter: { type: "date" } },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any[]) =>
    data?.map((item: any) => ({
      ...item,
      action: beautify(item?.action_label || item?.action),
      target_type: beautify(item?.target_type),
      timestamp: <NoWrap>{formatDateTime(item?.timestamp)}</NoWrap>,
      actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
    })) ?? [];

  const viewData = (item: any) => ({
    sections: [
      {
        title: "Audit Log Details",
        fields: {
          Actor: item?.actor_name || item?.actor || "—",
          Action: beautify(item?.action_label || item?.action),
          "Target Type": beautify(item?.target_type),
          "Target ID": item?.target_id || "—",
          "Correlation ID": item?.correlation_id || "—",
          "IP Address": item?.ip_address || "—",
          Timestamp: formatDateTime(item?.timestamp),
        },
      },
      ...(item?.details && Object.keys(item.details).length > 0
        ? [
            {
              title: "Details",
              fields: Object.fromEntries(
                Object.entries(item.details).map(([k, v]) => [
                  beautify(k),
                  String(v ?? "—"),
                ]),
              ),
            },
          ]
        : []),
    ],
  });

  return { tableColumns, tableData, viewData };
};
